import { RootState } from '../store';

export const getTableServers = (state: RootState) => state.servers.table;

export const getServerName = (state: RootState) => {
    return (hostname: string) => {
        return hostname;
    };
};

export const serverOptions = (state: RootState) => {
    return state.servers.all.map((server) => {
        return {
            label: server.hostname,
            value: server.hostname,
        };
    });
};

export const getSingleServer = (state: RootState) => state.servers.singleServer;